export const COLLECTION_NAME = "TEAMS";
export const DASHBOARD_PATH = "/game_results_dashboard";
export const GAME_PATH = "/game";
export const QUESTION_SCORE = 5;
export const FALSE_ANSWER_TIME_EFFECT = 10; // seconds

export const GAME_DESCRIPTION =
  "You’ll be given a set of questions. Your goal is to answer each question by taking a picture of the person that represents the answer of the question in the shortest time. Every right answer will be awarded 5 points. Wrong answer will be demoted 5 points & 20 seconds added to your clock. The winner is the highest score in the shortest amount of time. Good luck!";
